<script>
    import { createEventDispatcher } from 'svelte'
    // import { Link, navigateTo } from 'yrv'
    import ActionButton from '../../components/ActionButton/ActionButton.svelte'
    // import TouchIcon from '../../components/TouchIcon/TouchIcon.svelte'
    import ListItem from '../../components/ListItem/ListItem.svelte'
    import Dialog from '../../components/Modal/Dialog.svelte'
    // import TagItem from '../../components/Tags/TagItem.svelte'
    // import moment from 'moment'
    

    export let data

    const dispatch = createEventDispatcher ();

    let deleteDialog    = false,
        disableBusy     = false,
        disabled        = data.disabled;

    const disableItem = event => {
        new Promise ((resolve, reject) => {
            disableBusy = true;
            dispatch ('disable', {
                bean: data,
                resolve,
                reject
            })
        }).then (() => {
            disableBusy = false; 
            // disabled = !disabled
        }).catch (() => {
            disableBusy = false
        })
    }

    const deleteItem = (event) => {
        deleteDialog = true
    }

    const editItem = (event) => {
        dispatch ('edit', {
            bean: data
        })
    }

    const cancelDelete = () => {
        deleteDialog = false
    }

    const confirmDelete = () => {
        deleteDialog = false;
        dispatch ('delete', {
            bean: data
        })
    }
</script>

<style>
    .UserItem :global(.ListItem) {
        transition: background-color .2s, transform .2s;
    }
    .UserItem.disabled :global(.ListItem) {
        background-color: #ffe9e9;
        transform: translate3d(40px, 0, 0);
        width: calc(100% - 40px);
    }
    .UserItem .icon {
        float: left;
        width: 60px;
        height: 60px;
        overflow: hidden;
        text-align: center;
        line-height: 60px;
        font-size: 20px;
    }
    .UserItem .icon .image-holder {
        display: inline-block;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        margin-top: 10px;
        vertical-align: top;
    }
    .UserItem .icon img {
        width: 100%;
        border-radius: 50%;
        vertical-align: top;
    }
    .UserItem .meta {
        float: left;
        width: calc(100% - 60px);
        padding: 10px;
    }
    .UserItem :global(.block) {
        padding: 5px 0;
        /* width: calc(100% - 50px);
        float: left; */
    }
    .UserItem .ops {
        float: right;
        width: 50%;
        padding-left: 6px;
        text-align: left;
    }


    .UserItem .lbl {
        font-weight: 600;
    }
    .UserItem .txt {
        font-size: 12px;
        color: var(--text-secondary);
        line-height: 14px;
    }

    .dialog-meta {
        margin-top: 10px;
    }
    .dialog-meta .lbl {
        font-weight: 600;
    }
    .dialog-meta .txt {
        font-size: 12px;
        color: var(--text-secondary);
        line-height: 14px;
    }

    @media(min-width: 800px) {
        .UserItem {
            width: 360px;
        }
    }
</style>


<div class="UserItem clearfix" class:disabled={data.disabled}>
    <ListItem classes="block clearfix" actions on:click={editItem}>
        <div class="icon">
            {#if data.disabled}
                <i class="far fa-ban"></i>
            {:else if data.image}
                <div class="image-holder">
                    <img src={data.image} alt="User avatar"/>
                </div>
            {:else}
                <i class="far fa-user-hard-hat"></i>
            {/if}
        </div>
        <div class="meta">
            <div class="lbl">{data.username}</div>
            <div class="txt">
                {data.name}
            </div>
        </div>
        <div class="ops">
            
        </div>
        
        <div slot="actions">
            <ActionButton icon="far fa-pencil" on:click={editItem} />
            <ActionButton icon="far fa-power-off" busy={disableBusy} disabled={disableBusy} visited={disabled} on:click={disableItem} />
            <ActionButton icon="far fa-trash" danger on:click={deleteItem} />
        </div>
    </ListItem>
</div>


{#if deleteDialog}
    <Dialog 
        title="Vuoi davvero eliminare questo utente?" 
        on:cancel={cancelDelete} 
        on:confirm={confirmDelete}
        leftAlign>
        <div class="dialog-meta">
            <div class="lbl">{data.name}</div>
            <div class="txt">{data.username}</div>
        </div>
    </Dialog>
{/if}